// extracted by mini-css-extract-plugin
export default {"infoButton":"section-info-button_infoButton__x1Sqb","infoIcon":"section-info-button_infoIcon__t5mwU"};